import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import styles from './style.module.css';

import {
  faChevronDown,
  faCircleInfo,
  faTrash,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Button, InputDropdown, InputField } from '../../elements';
import WaterInputGroup from '../WaterInputGroup';

export default function AccordionFieldGroup(props) {
  const {
    className,
    data,
    categoryId,
    handleDeleteWaterData,
    postLoading,
    setPostLoading,
    inputListSliced,
  } = props;

  const [activeList, setActiveList] = useState([]);

  const classes = [styles.root, className].filter(Boolean).join(' ');

  const description1Value =
    categoryId === 98
      ? `0 - Air terproduksi tidak digunakan untuk tujuan bisnis apa pun - Tingkat kepentingan nol akan berlaku untuk sumber air terproduksi yang tidak digunakan untuk tujuan bisnis apa pun. Tingkat kepentingan nol tidak diperbolehkan untuk sumber pengaruh lain yang digunakan oleh wilayah operasi. Jika sumber digunakan, maka terdapat beberapa kepentingan.\n\n1 - Kecil – Penggantian Sederhana - Air dari sumber influen ini dapat diganti dengan sumber lain atau dengan teknologi proses tanpa air dengan biaya dan jangka waktu minimal. Sumber alternatif telah diidentifikasi dan dapat diperoleh dengan izin minimal atau upaya lain.\n\n2 - Sedang – Alternatif Memerlukan Biaya dan Waktu Ekstra untuk Implementasi - Penggantian sumber influen ini dengan sumber lain atau teknologi tanpa air dimungkinkan tetapi mungkin memerlukan waktu tunggu yang moderat untuk diterapkan. Sumber alternatif telah diidentifikasi dan dapat diperoleh dengan sedikit usaha (proses perizinan normal atau teknologi yang diketahui).\n\n3 - Tinggi – Tidak Ada Alternatif, Biaya Tinggi atau Jangka Waktu Panjang. - Penggantian sumber influen ini akan sulit atau tidak mungkin. Biaya penggunaan sumber alternatif atau teknologi tanpa air kemungkinan besar akan signifikan secara ekonomi bagi operasi. Jangka waktu implementasi mungkin lama. Tidak ada sumber alternatif yang jelas atau upaya yang signifikan akan diperlukan untuk mendapatkan air dari sumber alternatif (seperti proses perizinan yang sulit atau teknologi yang belum terbukti atau mahal).\n\n`
      : `0 - Tidak termasuk - Tingkat kepentingan nol tidak diperbolehkan untuk badan air penerima yang digunakan oleh suatu lokasi. Jika ada pelepasan ke suatu titik, itu memiliki beberapa kepentingan.\n\n1 - Kecil – Penggantian Sederhana - Pembuangan ke badan air atau entitas penerima ini dapat diganti dengan titik pembuangan lain atau dengan teknologi pembuangan air nol dengan biaya dan jangka waktu minimal. Titik pembuangan alternatif telah diidentifikasi dan dapat diperoleh dengan izin minimal atau upaya lain.\n\n2 - Sedang – Alternatif Memerlukan Biaya dan Waktu Ekstra untuk Implementasi - Penggantian pembuangan ke badan air atau entitas penerima ini ke titik pembuangan lain atau dengan teknologi pembuangan air nol dimungkinkan tetapi mungkin memerlukan waktu tunggu yang moderat untuk diterapkan. Titik pembuangan alternatif telah diidentifikasi dan dapat diperoleh dengan sedikit usaha (proses perizinan normal atau teknologi yang diketahui).\n\n3 - Tinggi – Tidak Ada Alternatif, Biaya Tinggi atau Jangka Waktu Panjang. - Penggantian pembuangan ke badan air atau badan penerima ini ke titik pembuangan lain akan sulit atau tidak mungkin. Biaya pembuangan ke titik alternatif atau teknologi pembuangan tanpa air kemungkinan besar akan signifikan secara ekonomi bagi operasi. Jangka waktu implementasi mungkin lama. Tidak ada titik pembuangan alternatif yang jelas atau upaya yang signifikan diperlukan untuk membuang limbah ke titik pembuangan (seperti proses perizinan yang sulit atau teknologi yang belum terbukti atau mahal).\n\n`;

  const handleHeaderClick = (e, index) => {
    if (
      (e.target.className === styles.itemHeader) |
      (e.target.className.baseVal
        ? +e.target.className.baseVal.search(styles.arrow) !== -1
        : false)
    ) {
      // cara 1---- (gagal)
      // let activeListVar = activeList;
      // activeListVar[index] = !activeListVar[index];
      // console.log('activelist var', activeListVar);
      // setActiveList([]);
      // setActiveList(activeListVar);

      // cara 2----
      const newActiveList = [];

      // loop with total accordion item
      activeList.forEach((element, i) => {
        // check if this are the clicked item or not
        if (i === index) {
          // invert the value
          newActiveList.push(!activeList[i]);
        } else {
          // if not the clicked item, don't change the value
          newActiveList.push(activeList[i]);
        }
      });

      // update the state value
      setActiveList(newActiveList);
    }
  };

  useEffect(() => {
    if (data) {
      // set initial active state all accordion items
      let initialActiveList = [];
      data.forEach((item, index) => {
        if (index === 0) {
          initialActiveList.push(true);
        } else {
          initialActiveList.push(false);
        }
      });

      console.log('initial active list', initialActiveList);
      setActiveList(initialActiveList);
    }
  }, [data]);

  return (
    <div className={classes}>
      {/* {console.log('data water', data)} */}
      {/* {console.log('activeList water', activeList)} */}
      {data.length === 0 && (
        <span className={styles.emptyData}>tidak ada data</span>
      )}
      {data &&
        data.map((item, index) => (
          <AccordionGroupItem
            item={item}
            key={`accordiongroup-item-${item.name}-${index}`}
            categoryId={categoryId}
            isActive={activeList[index]}
            handleHeaderClick={(e) => handleHeaderClick(e, index)}
            handleDeleteWaterData={handleDeleteWaterData}
            postLoading={postLoading}
            setPostLoading={setPostLoading}
            description1Value={description1Value}
            inputListSliced={inputListSliced}
          />
        ))}
    </div>
  );
}

const AccordionGroupItem = ({
  item,
  categoryId,
  isActive,
  handleHeaderClick,
  handleDeleteWaterData,
  postLoading,
  setPostLoading,
  description1Value,
  inputListSliced,
}) => {
  return (
    <div className={styles.itemContainer}>
      <div className={styles.itemHeader} onClick={handleHeaderClick}>
        <h3>{item.name}</h3>
        <div className={styles.iconGroupWrapper}>
          <FontAwesomeIcon
            icon={faTrash}
            className={styles.deleteIcon}
            onClick={() => {
              if (!postLoading) {
                Swal.fire({
                  title: 'Are you sure?',
                  text: "You won't be able to revert this!",
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'Yes, delete it!',
                  cancelButtonText: 'Cancel',
                }).then((result) => {
                  if (result.isConfirmed) {
                    handleDeleteWaterData(item.id);
                  }
                });
              }
            }}
            disabled={postLoading}
          />
          <FontAwesomeIcon
            icon={faChevronDown}
            className={`${styles.arrow} ${isActive && styles.active}`}
          />
        </div>
      </div>
      <div className={`${styles.itemContent} ${isActive && styles.active}`}>
        <form>
          <InputField
            name={categoryId === 98 ? 'waterSource' : 'waterReceivingBody'}
            type="text"
            label={categoryId === 98 ? 'Sumber Air' : 'Badan Penerima Air'}
            className={styles.input}
            defaultValue={item.name}
            disabled
          />
          <InputField
            name="coordinate"
            type="text"
            label="Koordinat"
            className={styles.input}
            defaultValue={item.coordinate}
            disabled
          />
          <InputDropdown
            name={
              categoryId === 98
                ? 'waterSourceImportance'
                : 'waterReceivingBodyImportance'
            }
            label={
              categoryId === 98
                ? 'Tingkat kepentingan internal sumber air'
                : 'Tingkat kepentingan internal badan penerima air'
            }
            className={styles.input}
            options={[0, 1, 2, 3]}
            onAdditionalButtonClick={(desc) => {
              Swal.fire({
                title: 'Deskripsi Nilai (0-3)',
                html: `<p class="align-left">${desc
                  .split('\n')
                  .join('<br/>')}</p>`,
                confirmButtonText: 'Saya Mengerti',
                confirmButtonColor: '#006CB7',
              });
            }}
            iconButton={faCircleInfo}
            description={description1Value}
          />
          <hr className={styles.dropdownDivider} />
          <div className={styles.accordionInputWrapper}>
            <WaterInputGroup
              inputListSliced={inputListSliced}
              additionalInputClassname={styles.input}
            />
          </div>
          <Button
            label="Submit"
            type="submit"
            color="primary"
            // onClick={() => setSubmitState('submit')}
            disabled={postLoading}
          />
          <Button
            label="Save"
            type="submit"
            color="secondary"
            // onClick={() => setSubmitState('save')}
            className={styles.btnSave}
            disabled={postLoading}
          />
        </form>
      </div>
    </div>
  );
};
